import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=3c538d8e&scoped=true&"
import script from "./Entity.vue?vue&type=script&lang=js&"
export * from "./Entity.vue?vue&type=script&lang=js&"
import style0 from "./Entity.vue?vue&type=style&index=0&id=3c538d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c538d8e",
  null
  
)

export default component.exports